import EmployeeStatistics from './EmployeeStatistics';

export default EmployeeStatistics;
